import { useState, KeyboardEvent } from "react";

import { TextField, InputAdornment } from "@mui/material";
import { Search } from "@mui/icons-material";

import { locationSearchInputStyles } from "./LocationSearchInput.styles";

interface LocationSearchInputProps {
    onSearch: (query: string) => void;
}

const LocationSearchInput = ({ onSearch }: LocationSearchInputProps) => {
    const [searchQuery, setSearchQuery] = useState("");

    const handleKeyDown = (event: KeyboardEvent<HTMLInputElement>) => {
        if (event.key === "Enter") {
            onSearch(searchQuery);
        }
    };

    const handleSearchClick = () => {
        onSearch(searchQuery);
    };

    return (
        <TextField
            fullWidth
            placeholder="City, State, or Zip Code"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            onKeyDown={handleKeyDown}
            sx={locationSearchInputStyles.searchInput}
            InputProps={{
                startAdornment: (
                    <InputAdornment position="start">
                        <Search
                            onClick={handleSearchClick}
                            sx={locationSearchInputStyles.searchIcon}
                        />
                    </InputAdornment>
                ),
            }}
        />
    );
};

export default LocationSearchInput;